import React from 'react';

import { Select } from 'antd';
import { presenceTypeOptions } from '../../data/options';

const SelectPresenceType = ({ ...props }) => {
  return (
    <Select
      {...props}
      placeholder="Pilih tipe"
      style={{
        width: '100%',
      }}
      options={presenceTypeOptions}
    />
  );
};
export default SelectPresenceType;
